module.exports = __webpack_public_path__ + "static/media/envelope-redo.6e7cc875.svg";